import { FreelancerProfile } from '../../types/profile';
import { useTranslation } from 'react-i18next';

interface ProfileServiceSectionSectionProps {
  profile: FreelancerProfile;
  className?: string;
}

const ProfileServicesSection = ({ profile, className }: ProfileServiceSectionSectionProps) => {
  const { t } = useTranslation(['freelancers']);
  return (
    <div
      className={`bg-white rounded-2xl border-2 shadow-xl border-gray-300 mb-6 py-6 px-6 ${className}`}
    >
      <div className="mb-2 text-lg font-bold text-secondary">
        {t('services', { defaultValue: 'Services' })}
      </div>

      <div className="md:scrollbar-thin md:scrollbar-thumb-[#B5C9D6] mb-1 flex flex-wrap gap-2 overflow-x-auto md:space-x-2 md:overflow-x-auto">
        {profile.services?.map(item => (
          <button
            key={item.id}
            className="font-ambit flex w-full items-center justify-center gap-1 rounded-full border border-secondary-light border-opacity-40 bg-transparent px-2 text-sm font-bold text-secondary focus:outline-none md:w-auto md:py-1"
            aria-label={t('common:remove')}
          >
            <span className="font-bold">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProfileServicesSection;
